import { api, ApiResponse, authHeader } from '@you-go-vn/components';
import { PromotionDetail } from '../data';

const genPromotionsAPI = (restaurantId: number) =>
  `/api/restaurants/${restaurantId}/promotions`;
type Item = PromotionDetail;
type Data = {
  items: Item[];
  total: number;
  totalPage: number;
};

type GetParams = {
  page?: number;
  limit?: number;
  keywords?: string;
};

const getYougoPromotionsRestaurantJoined = async (
  restaurantId: number,
  params?: GetParams,
) => {
  return api.get<ApiResponse<Data>>(
    genPromotionsAPI(restaurantId) + '/joined',
    {
      params: params,
      headers: authHeader(),
    },
  );
};

const getYougoPromotionsRestaurantCanJoin = async (
  restaurantId: number,
  params?: GetParams,
) => {
  return api.get<ApiResponse<Data>>(
    genPromotionsAPI(restaurantId) + '/can-join',
    {
      params: params,
      headers: authHeader(),
    },
  );
};

const joinYougoPromotions = async (restaurantId: number, id: number) => {
  return api.post<ApiResponse<Data>>(
    genPromotionsAPI(restaurantId) + '/can-join/' + id + '/join',
    {},
    {
      headers: authHeader(),
    },
  );
};

export const yougoPromotionServices = {
  getYougoPromotionsRestaurantJoined,
  getYougoPromotionsRestaurantCanJoin,
  joinYougoPromotions,
  // outYougoPromotions,
};
